const BIOMETRIC_CHOICE_KEY = 'biometric_choice';

export type BiometricChoice = 'enabled' | 'declined';

export const getBiometricChoice = (): BiometricChoice | null => {
  return localStorage.getItem(BIOMETRIC_CHOICE_KEY) as BiometricChoice | null;
};

export const setBiometricChoice = (choice: BiometricChoice | null): void => {
  if (choice === null) {
    localStorage.removeItem(BIOMETRIC_CHOICE_KEY);
  } else {
    localStorage.setItem(BIOMETRIC_CHOICE_KEY, choice);
  }
};

export const shouldShowBiometricOptIn = (): boolean => {
  return getBiometricChoice() === null;
};
